import { render, staticRenderFns } from "./externalDynamicDetailPage.vue?vue&type=template&id=556d591a&"
import script from "./externalDynamicDetailPage.vue?vue&type=script&lang=js&"
export * from "./externalDynamicDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./externalDynamicDetailPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports